<app-template-notification [value]="value" [control]="control" [severity]="severity" />
